/**
 * First we will load all of this project's JavaScript dependencies which
 * includes other libraries. It is a great starting point when
 * building robust, powerful web applications.
 */

try {
    window.$ = window.jQuery = require('jquery');
    window.QRCode = require('qrcodejs');
} catch (e) {}

// Livewire
require('./bootstrap');

import flatpickr from 'flatpickr';
import { Polish } from "flatpickr/dist/l10n/pl.js";

// Set Flatpickr global instance and locale
window.flatpickr = flatpickr;
flatpickr.localize(Polish);

window.he = require("he");

window.storage = require("./tools/storage");
window.helpers = require("./tools/helpers");

const ToastManager = require("./libs/ToastManager");
window.toastManager = new ToastManager();

import Swal from "sweetalert2";
const { installThemedSwal, getSwalThemeOptions } = require("./tools/swal-theme");
installThemedSwal(Swal);
window.Swal = Swal;
window.getSwalThemeOptions = getSwalThemeOptions;

//module to handle tab control on the page
window.TabsManager = require("./tools/tab-control.js");

const themeManager = require("./tools/theme-manager");
window.themeManager = themeManager;
document.addEventListener("DOMContentLoaded", () => themeManager.initThemeManager());

const sidebarManager = require("./tools/sidebar-manager");
window.sidebarManager = sidebarManager;
document.addEventListener("DOMContentLoaded", () => sidebarManager.initSidebarManager());

const postalCodeLookup = require("./tools/postal-code-lookup");
window.labnetPostalCodeLookup = window.labnetPostalCodeLookup || {};
window.labnetPostalCodeLookup.fillPairWithoutLookup = postalCodeLookup.fillPostalCodePairWithoutLookup;

const digitFields = require("./tools/digit-fields");
document.addEventListener("DOMContentLoaded", () => digitFields.initDigitFields());
document.addEventListener("livewire:init", () => {
    digitFields.initDigitFields();
    if (window.Livewire?.hook) {
        window.Livewire.hook("morph.updated", ({ el }) => digitFields.initDigitFields(el));
    }
});

const busyButton = require("./tools/busy-button");
// Globalny helper do pokazania spinnera / blokady przy dłuższych akcjach UI.
window.uiBusyIndicator = busyButton;
document.addEventListener("DOMContentLoaded", () => busyButton.initBusyOnClick());
document.addEventListener("livewire:init", () => {
    busyButton.initBusyOnClick();
    if (window.Livewire?.hook) {
        window.Livewire.hook("morph.updated", ({ el }) => busyButton.initBusyOnClick(el));
    }
});

import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
window.notyf = new Notyf({
    duration: window.toastDisplayDuration || 7000,
    position: { 
        x: 'right', 
        y: 'top' 
    },
    dismissible: true,
    types: [
        {
            type: 'success',
            background: '#4caf50',
            icon: false
        },
        {
            type: 'error',
            background: '#f44336',
            icon: false
        },
        {
            type: 'info',
            background: '#2196f3',
            icon: false
        },
        {
            type: 'warning',
            background: '#ff9800',
            icon: false
        }
    ]
});

window.addEventListener('welder-type-selected', function(event) {
    const typeInput = document.getElementById('type');
    if (typeInput) {
        typeInput.classList.add('highlighted');
        setTimeout(() => typeInput.classList.remove('highlighted'), 1500);
    }
    if (window.notyf) {
        window.notyf.success('Wybrano typ: ' + event.detail.type);
    }
});
